import MyService from '../../service';

export const VEHICLE_TYPES = {
  CAR: 1,
  MOTOBIKE: 2,
};

const TypeApi = {
  getAll: async () => {
    let result = [];
    await MyService.getRequestData('/vehicles/type')
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default TypeApi;
